import WordCloudController from './WordCloudController.js'
import WordCloudView from './WordCloudView.vue'

export default WordCloudController(WordCloudView)
